<template>
    <a-row class="header-panel">
        <a-col>
            <span class="selected-time" v-html="getHeaderLabel()"></span>
        </a-col>
    </a-row>

    <a-table :columns="wasteType == 1 ? column : columnRegular" :dataSource="listAchievementDetails" :pagination="false" :scroll="{x: '600px', y: tableHeight}">
        <template #bodyCell="{ column, text, record }">
            <template v-if="column.dataIndex === 'type'">
                <span>{{ wasteType == 1 ? $t('INDUSTRIAL') : $t('REGULAR') }}</span>
            </template>
            <template v-if="column.dataIndex === 'manifestId'">
                <router-link :to="'/manifest-detail?manifestNumber=' + text">{{ text }}</router-link>
            </template>
            <template v-if="column.dataIndex === 'transportVolume'">
                <template v-if="wasteType == 1">
                    <a-button class="link-detail" type="link" @click="openPopupDetail(record)">
                        {{ AchievementService.convertWeight(record.transportVolume) + record.transportVolumeUnit }}
                    </a-button>
                </template>
                <template v-else>
                    <span>{{ AchievementService.convertWeight(record.transportVolume) + 'kg' }}</span>
                </template>
            </template>
            <template v-if="column.dataIndex === 'status'">
                <template v-if="record.status === ACHIEVEMENT.STATUS.ACCEPTANCE_OR_DENIAL || record.status === ACHIEVEMENT.STATUS.REQUEST_DELETE">
                    <span class="status">{{ $t(authStore.isDischarger ? 'awaiting_approval_2' : 'awaiting_approval') }}</span>
                </template>
                <template v-if="record.status === ACHIEVEMENT.STATUS.REJECTION">
                    <span class="status">{{ $t('rejection') }}</span>
                </template>
                <template v-else>
                    <span></span>
                </template>
            </template>
            <template v-if="['wasteName', 'transporter', 'projectTitle'].includes(column.dataIndex)">
                <div class="ant-table-cell-ellipsis">
                  <a-tooltip :title="text" placement="topLeft">
                    <span >{{ text }}</span>
                  </a-tooltip></div>
              </template>
        </template>
    </a-table>

    <a-button
        class="download-csv"
        @click="downloadCsv"
        :disabled="listAchievementDetails == undefined || listAchievementDetails.length == 0"
    >
        {{ $t('output_result_as_csv') }}
    </a-button>

    <PopupTransportIndustryWasteDetails :visible="isOpenPopupDetail" :id="selectedAchievementId" @close="closePopupDetail" @update="updateData" @delete="deleteData"/>
</template>

<script setup lang="ts">
    import AchievementService from '@/services/modules/AchievementService';
    import PopupTransportIndustryWasteDetails from './PopupTransportIndustryWasteDetails.vue';
    import { ref, onMounted, watch } from 'vue';
    import { useRoute, useRouter } from 'vue-router'
    import { useI18n } from 'vue-i18n';
    import { useAuthStore, useCommonStore, useAchievementStore, useUserStore } from '@/stores';
    import { ACHIEVEMENT } from '@/constants';
    import { storeToRefs } from 'pinia';
    import { customEllipsis } from '@/services/modules/home';

    const adminSelectedTransportCompanyId = ref();
    const route = useRoute();
    const router = useRouter();
    const selectedYear = ref<string>();
    const selectedMonth = ref<string>();
    const listAchievementDetails = ref<any>();
    const isOpenPopupDetail = ref<boolean>(false);
    const {t} = useI18n();
    const currentDetail = ref<any>();
    const authStore = useAuthStore();
    const achievementStore = useAchievementStore();
    const selectedAchievementId = ref();
    const tableHeight = ref('0px');
    const commonStore = useCommonStore();
    const { selectedCompanyId } = storeToRefs(commonStore);
    const wasteType = ref<any>();
    const wasteCode = ref<any>();
    const wasteCompanyId = ref<number>();

    const centerHeader = () => {
        return {
            style: {
                textAlign: 'center',
            },
        };
    }

    const rightCell = () => {
        return {
            style: {
                textAlign: 'right',
            },
        };
    }

    const column = [
        { title: t('type'), dataIndex: 'type', key: 'type', width: 150, customHeaderCell: centerHeader },
        { title: t('waste_name'), dataIndex: 'wasteName', key: 'wasteName', width: 200, customHeaderCell: centerHeader,customCell:customEllipsis },
        { title: t('project_title'), dataIndex: 'projectTitle', key: 'projectTitle', width: 300, customHeaderCell: centerHeader,customCell:customEllipsis },
        { title: t('manifest_number'), dataIndex: 'manifestId', key: 'manifestId', width: 150, align: 'center' },
        { title: t('transportation_end_date'), dataIndex: 'endDateTransport', key: 'endDateTransport', width: 110, align: 'center' },
        { title: t('transport_volume'), dataIndex: 'transportVolume', key: 'transportVolume', width: 150, customCell: rightCell, customHeaderCell: centerHeader },
        { title: t('transporter'), dataIndex: 'transporter', key: 'transporter', width: 150, customHeaderCell: centerHeader,customCell:customEllipsis },
        { title: t('admit_reject'), dataIndex: 'status', key: 'status', width: 130, align: 'center' },
    ];

    const columnRegular = [
        { title: t('type'), dataIndex: 'type', key: 'type', width: 150, align: 'center' },
        { title: t('waste_name'), dataIndex: 'wasteName', key: 'wasteName', width: 200, customHeaderCell: centerHeader,customCell:customEllipsis },
        { title: t('project_title'), dataIndex: 'projectTitle', key: 'projectTitle', width: 300, customHeaderCell: centerHeader,customCell:customEllipsis },
        { title: t('collection_date'), dataIndex: 'collectiondate', key: 'collectiondate', width: 120, align: 'center' },
        { title: t('transport_volume'), dataIndex: 'transportVolume', key: 'transportVolume', width: 150, customCell: rightCell, customHeaderCell: centerHeader },
    ];

    watch(route, (to) => {
        if (!to.path.startsWith('/achievements') && !to.path.startsWith('/achievements/detail')) {
            achievementStore.filter = undefined;
        }
    });

    onMounted(async() => {
        if(route.query.year == null) {
            router.push({ path: '/home' });
        } else {
            window.addEventListener('resize', updateTableHeight);
            selectedYear.value = route.query.year.toString();
            selectedMonth.value = route.query.month?.toString();
            wasteType.value = route.query.wasteType;
            wasteCode.value = route.query.wasteCode;
            wasteCompanyId.value = route.query.wasteCompanyId != null ? Number(route.query.wasteCompanyId): (selectedCompanyId.value != null ? Number(selectedCompanyId.value)  : undefined);
            if(wasteType.value != 1) {
                router.push({ path: '/achievements' });
                return;
            }
            await search();
            updateTableHeight();
        }
    });

    const search = async() => {
        listAchievementDetails.value = await AchievementService.getAchievementDetail(authStore.userRoles, selectedYear.value, selectedMonth.value, wasteType.value, wasteCode.value,
            wasteCompanyId.value, adminSelectedTransportCompanyId.value != null ? adminSelectedTransportCompanyId.value : undefined);
        if(listAchievementDetails.value == null || listAchievementDetails.value.length == 0) {
            router.push({ path: '/achievements' });
        }
    }

    watch([selectedCompanyId], () => router.push({ path: '/achievements' }));

    const updateTableHeight = () => {
      const tableTop = document.querySelector('.ant-table-wrapper')?.getBoundingClientRect().top || 0;
      const csvBtnTop = document.querySelector('.download-csv')?.getBoundingClientRect().top || 0;
      tableHeight.value = `calc(${csvBtnTop}px - ${tableTop}px - 75px)`;
    };

    const getSelectedTimeLabel = (isExportCSV:boolean) => {
        if (selectedYear.value == null) {
            return '';
        } else if (selectedMonth.value == null) {
            return isExportCSV 
                ? selectedYear.value 
                : selectedYear.value + t('year_jp');
        } else {
            let month = Number(selectedMonth.value);
            return isExportCSV 
                ? selectedYear.value + (month < 10 ? '0' + month : month)
                : selectedYear.value + t('year_jp') + (month < 10 ? '0' + month : month) + t('month_jp');
        }
    }

    const getHeaderLabel = () => {
        let label = getSelectedTimeLabel(false);
        if(wasteType.value == 1) {
            label += ' ' + t('INDUSTRIAL');
        } else if(wasteType.value == 2) {
            label += ' ' + t('REGULAR');
        }
        if(listAchievementDetails.value != null && listAchievementDetails.value != undefined) {
            label += ' - ' + listAchievementDetails.value[0]?.wasteName;
        }
        if(listAchievementDetails.value != null && listAchievementDetails.value != undefined) {
            label += '&nbsp;&nbsp;&nbsp;' + listAchievementDetails.value[0]?.wasteCompanyName;
        }
        return label;
    }

    const openPopupDetail = (record: any) => {
        selectedAchievementId.value = record.id;
        currentDetail.value = record;
        isOpenPopupDetail.value = true;
    }

    const closePopupDetail = () => {
        isOpenPopupDetail.value = false;
    }

    const updateData = async () => {
        await search();
    }

    const deleteData = (id:number) => {
        listAchievementDetails.value = listAchievementDetails.value
            .filter((element:any) => element.id !== id);
        if(listAchievementDetails.value.length == 0) {
            router.push({ path: '/achievements' });
        }
    }

    const downloadCsv = async () => {
        let data:any = [];
        listAchievementDetails.value.forEach((element:any) => {
            let status = element.status != null && element.status != ACHIEVEMENT.STATUS.BLANK
                ? (element.status == ACHIEVEMENT.STATUS.ACCEPTANCE_OR_DENIAL || element.status === ACHIEVEMENT.STATUS.REQUEST_DELETE
                    ? (authStore.isDischarger ? t('awaiting_approval_2') : t('awaiting_approval')) : t('rejection'))
                : '';
            if(wasteType.value == 1) {
                let obj = {
                    [t('type')]: t('INDUSTRIAL'),
                    [t('waste_name')]: element.wasteName,
                    [t('project_title')]: element.projectTitle,
                    [t('manifest_number')]: element.manifestId,
                    [t('transportation_end_date')]: element.endDateTransport,
                    [t('transport_volume')]: AchievementService.convertWeight(element.transportVolume) + element.transportVolumeUnit,
                    [t('transporter')]: element.transporter,
                    [t('admit_reject')]: status,
                }
                data.push(obj);
            } else {
                let obj = {
                    [t('type')]: t('REGULAR'),
                    [t('waste_name')]: element.wasteName,
                    [t('project_title')]: element.projectTitle,
                    [t('collection_date')]: element.collectiondate,
                    [t('transport_volume')]: AchievementService.convertWeight(element.transportVolume) + 'kg',
                }
                data.push(obj);
            }
            
        });
        let fileName = 'gomikan_' + t('achievement_details') + '_' + getSelectedTimeLabel(true).replace('/', '') + '.csv';
        AchievementService.downloadCsv(data, fileName, getHeaderLabel().replaceAll('&nbsp;', ' '));
    }
</script>

<style lang="scss" scoped>

    span.status {
        width: 100px;
        padding-top: 5px;
        padding-bottom: 5px;
        border-radius: 5px;
        font-size: 12px;
        text-align: center;
        color: #FFFFFF;
        background-color: #F67E7E;
        display: inline-block;

    }

    .header-panel {
        
        .selected-time {
            padding-left: 5px;
            display: flex;
            justify-content: center;
            align-items: center;
            margin-bottom: 1rem;
        }

        .header-button {
            margin-bottom: 1rem;

            button {
                background-color: #F67E7E;
            }

            > div.ant-col:nth-child(1) {
                button {
                    margin-right: 10px;
                }
            }
        }

        @media (max-width: 341px) {
            .header-button {
                > div:nth-child(2) {
                    margin-top: 10px;
                }
            }
        }
    }

    .download-csv {
        border: 2px solid #5B9BD5;
        width: 200px;
        height: 40px;
        color: #5B9BD5;
        font-weight: bold;
        position: fixed;
        bottom: 50px;
        left: calc(280px + (100% - 280px)/2 - 100px);
    }

    @media (max-width: 991px) {
        .download-csv {
            left: calc(100%/2 - 100px);
        }
    }

    .link-detail {
        padding-right: 0px;
    }

    ::-webkit-scrollbar {
      width: 5px;
      height: 5px;
    }

    ::-webkit-scrollbar-track {
        background: #f1f1f1; 
    }
    
    ::-webkit-scrollbar-thumb {
        background: #888; 
    }

    ::-webkit-scrollbar-thumb:hover {
        background: #555; 
    }

    :deep(.ant-table-body::-webkit-scrollbar) {
        height: 4px;
        width: 4px;
    }

    :deep(.ant-table-body::-webkit-scrollbar-track) {
        background-color: #e1e6e6;
    }

    :deep(.ant-table-body::-webkit-scrollbar-thumb) {
        border-radius: 6px;
        background-color: gray;
    }

    :deep(.ant-table > .ant-table-container) {
        border: 1px solid gainsboro;
    }
</style>